import { useContext } from 'react';
import { ActiveEditingSectionContext } from '../providers/ActiveEditingSectionProvider';

export const useActiveEditingSectionContext = () => {
  return useContext(ActiveEditingSectionContext);
};
